import { render } from "./LikeCountIcon.vue?vue&type=template&id=edf82a6c"
import script from "./LikeCountIcon.vue?vue&type=script&lang=js"
export * from "./LikeCountIcon.vue?vue&type=script&lang=js"
script.render = render

export default script